import { useLocation } from "react-router";
import {
  useGetAiAssistantRoutePromptsSuggestions,
  useGetCurrentPageRoute,
} from "./AiAssistantPromptsSuggestions.hooks";
import type { AiAssistantPromptsSuggestionsProps } from "./AiAssistantPromptsSuggestions.types";
import { getStaticPromptsForRoute } from "./AiAssistantPromptsSuggestions.validations";
import PromptSuggestion from "./components/PromptSuggestion/PromptSuggestion";

export default function AiAssistantPromptsSuggestions({
  onSubmit,
  isLoading,
}: AiAssistantPromptsSuggestionsProps) {
  const route = useGetCurrentPageRoute();
  const { search } = useLocation();
  const dynamicPrompts = useGetAiAssistantRoutePromptsSuggestions();
  const staticPrompts = route
    ? getStaticPromptsForRoute(route.key, search)
    : undefined;
  const prompts =
    staticPrompts?.length || dynamicPrompts?.length
      ? [...new Set([...(staticPrompts ?? []), ...(dynamicPrompts ?? [])])]
      : [];

  if (!prompts.length) {
    return (
      <div>
        <p>Start a conversation</p>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      <p className="text-center text-text-secondary text-sm mb-3 w-full">
        Ask anything regarding the viewed data.
        <br />
        Here are some suggestions:
      </p>
      {prompts.map((p) => (
        <PromptSuggestion
          key={p}
          prompt={p}
          disabled={isLoading}
          onClick={() => {
            void onSubmit(p);
          }}
        />
      ))}
    </div>
  );
}
